import {createFileRoute, notFound} from "@tanstack/react-router";
import {PipelinePage} from "~/modules/dataPipeline/page";
import {views, type View} from "~/modules/dataPipeline/model";
import {Route as Parent} from "../route";
export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/data-pipeline/$view")({
    beforeLoad: ({params}) => {
        if (!views.includes(params.view as View)) {
            throw notFound();
        }
    },
    component: Page,
});
function Page() {
    return (
        <PipelinePage
            context={Parent.useLoaderData()}
            filters={Parent.useSearch()}
            view={Route.useParams().view as View}
        />
    );
}
